import { toast } from '@qodo/design-system';
import { useMutation } from '@tanstack/react-query';
import { spawn } from '../../utils/translations';
import {
  GitlabClient,
  GitlabConfigureMultiRequest,
} from '../httpClients/GitlabClient';
import { MUTATION_KEYS } from './consts';
import { getErrorToastContent } from './utils';

/**
 * Saves a multi-group pending config (B-v1a): connect several GitLab groups in
 * one run by pasting a newline-separated list of group URLs. Mirrors
 * useConfigureGitlabMutation but targets the configure-multi endpoint.
 */
export const useConfigureGitlabMultiMutation = () => {
  const spawnToasts = spawn('toasts.gitlab.configure');

  return useMutation({
    mutationKey: [MUTATION_KEYS.CONFIGURE_GITLAB_MULTI],
    mutationFn: async (request: GitlabConfigureMultiRequest) => {
      await GitlabClient.configureMulti(request);
    },
    onError: (err: unknown) => {
      const errorFromServer = getErrorToastContent(err, spawnToasts('error'));

      toast.error(errorFromServer);
    },
  });
};
